import { confirmar } from '../libs/cifra/dialogs';

// Los datos que se pasan son directramente los que usamos con swal
export default {
  beforeMount(el, bindings, _vnode) {
    el.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      confirmar(bindings.value).then((confirmacion) => {
        if (confirmacion === true) {
          const event = new Event('confirmado');
          el.dispatchEvent(event);
        }
      });
    });
  },
};
